import { EAssetCategory } from "../interfaces/presigned-url";

// Image uploader constants
export const IMAGE_UPLOADER_LIMITS = {
  MAX_FILE_SIZE: 10, // MB
  MIN_FILE_SIZE: 0.1, // MB
  MAX_WIDTH: 4096,
  MAX_HEIGHT: 4096,
  MIN_WIDTH: 100,
  MIN_HEIGHT: 100,
} as const;

// Accepted file types for image uploader
export const IMAGE_UPLOADER_ACCEPT = {
  IMAGES: "image/*",
  SPECIFIC: ".jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.ico,.tiff,.tif",
} as const;

// Asset category display names
export const ASSET_CATEGORY_LABELS = {
  [EAssetCategory.BANNER_IMAGE]: "Banner Image",
  [EAssetCategory.BLOG_IMAGE]: "Blog Image", 
  [EAssetCategory.USER_PROFILE_IMG]: "Profile Image",
  [EAssetCategory.PET_PROFILE_IMG]: "Pet Image",
  [EAssetCategory.HEALTH_RECORD]: "Health Record",
} as const;

// Upload status messages
export const UPLOAD_STATUS_MESSAGES = {
  UPLOADING: "Uploading image...",
  SUCCESS: "Image uploaded successfully",
  ERROR: "Failed to upload image",
  INVALID_FILE: "Invalid file type or size",
  GENERATING_URL: "Generating upload link...",
} as const;

// Error messages
export const IMAGE_UPLOADER_ERRORS = {
  FILE_TOO_LARGE: `File size must be less than ${IMAGE_UPLOADER_LIMITS.MAX_FILE_SIZE}MB`,
  FILE_TOO_SMALL: `File size must be at least ${IMAGE_UPLOADER_LIMITS.MIN_FILE_SIZE}MB`,
  INVALID_TYPE: "Please select a valid image file",
  UPLOAD_FAILED: "Failed to upload image. Please try again.",
  URL_GENERATION_FAILED: "Failed to generate upload link. Please try again.",
  DIMENSIONS_TOO_LARGE: `Image dimensions must be less than ${IMAGE_UPLOADER_LIMITS.MAX_WIDTH}x${IMAGE_UPLOADER_LIMITS.MAX_HEIGHT}`,
  DIMENSIONS_TOO_SMALL: `Image dimensions must be at least ${IMAGE_UPLOADER_LIMITS.MIN_WIDTH}x${IMAGE_UPLOADER_LIMITS.MIN_HEIGHT}`,
} as const;


export const DEFAULT_ASSET_TYPES: Record<EAssetCategory, string> = {
  [EAssetCategory.BANNER_IMAGE]: "home",
  [EAssetCategory.BLOG_IMAGE]: "featured",
  [EAssetCategory.USER_PROFILE_IMG]: "profile",
  [EAssetCategory.PET_PROFILE_IMG]: "pet",
  [EAssetCategory.HEALTH_RECORD]: "health",
  [EAssetCategory.PRODUCT_IMAGE]: "product",
};